import lastDateByPeriod from 'utils/pivot/date/lastDateByPeriod'
import { REQUIRED_ERROR_MESSAGE } from 'messages'
import { alterDate, stringToDate } from '@hc-frontend/utils'

function endDate({ sDate, endDate, period }) {
  endDate = endDate instanceof Date ? endDate : stringToDate(endDate)

  if (!endDate) return REQUIRED_ERROR_MESSAGE

  sDate = sDate instanceof Date ? sDate : stringToDate(sDate)
  endDate = endDate.getTime()

  const minDays = period === 364 || period === 330 ? 180 : 29
  const minDate = alterDate({
    date: sDate,
    days: minDays
  })

  const maxDate = lastDateByPeriod(sDate, period)
  if (endDate < minDate.getTime()) {
    return `Coverage must be at least ${minDays + 1} days in duration`
  }

  if (maxDate.getTime() < endDate) {
    return `Coverage cannot be more than ${period} days in duration.`
  }

  return ''
}

export default endDate
